import {
  defaultLayouts,
  defaultPadding,
  GSEmptyList,
  GSItemList,
  GSSidePanelPage,
} from "golfstatus_react_components";
import {
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";

//import scss
import { useNotificationBanner } from "../../../hooks/notificationHooks";
import { selectCurrentTournament } from "../../../reducers/tournamentSlice";
import {
  getTournamentTeam,
  getTournamentTeamRounds,
  selectCurrentTeam,
  selectTournamentTeamRounds,
} from "../../../reducers/teamsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import TournamentTeamDetailHero from "./tournament-team-detail-hero";
import TournamentTeamRoundCheckinItem from "./tournament-team-round-check-in-item";
import {
  selectLoading,
  selectNotifications,
} from "../../../reducers/checkinSlice";
import { useTournamentCheckins } from "../../../hooks/checkIn/checkInHooks";

//Name the component
const TournamentTeamCheckIn = (props) => {
  const match = useMatch("/:tournamentID/teams/:teamID/checkin");
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");

  const teamID = match?.params?.teamID;

  const currentTournament = useSelector(selectCurrentTournament);
  const teamRounds = useSelector(selectTournamentTeamRounds);
  const currentTeam = useSelector(selectCurrentTeam);

  const loading = useSelector(selectLoading);
  const isLoading = loading?.includes?.("getTournamentCheckIns");

  const {getTeamCheckIns} = useTournamentCheckins(true)

  const teamRoundCheckins = getTeamCheckIns(teamRounds, currentTeam, search)?.mappedCheckins

  const pendingNotifications = useSelector(selectNotifications)?.filter?.(
      (n) => n.result === "pending",
    );

  useEffect(() => {
    if (teamID) {
      dispatch(getTournamentTeamRounds(teamID));
      dispatch(getTournamentTeam(teamID));
    }
  }, [teamID, dispatch]);


  const navigate = useNavigate();
  const notifications = [];

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Hole Assignments & Checkin`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const emptyList = () => {
    return <GSEmptyList
        style={{ ...defaultPadding.smallLayoutPad.apply("vertical") }}
        title="We could not find round you were looking for..."
        detail="Please refine your search and try again."
        actions={[
          {
            title: "Clear Search",
            type: "grey",
            onClick: () => {
              setSearch("")
            },
          },
        ]}
      />
  }

  const getContent = () => {
    return (
      <div style={{ ...defaultLayouts.fill, ...defaultLayouts.vStack }}>
        <TournamentTeamDetailHero
          style={{
            ...defaultPadding.xLargePad.apply("horizontal"),
            ...defaultPadding.smallLayoutPad.apply("vertical"),
            borderBottom: "1px solid #eee",
          }}
          {...currentTeam}
          team={currentTeam}
          tournament={currentTournament}
        />
        <GSItemList
          items={teamRoundCheckins}
          type="vertical"
          emptyMessage={emptyList()}
          listItem={(teamRound) => (
            <TournamentTeamRoundCheckinItem
              style={{
                ...defaultPadding.xLargePad,
                ...defaultLayouts.fullWidth,
                borderBottom: "1px solid #eee",
              }}
              teamRound={teamRound}
              pending={pendingNotifications?.some?.(n =>
                  n?.payload?.meta?.arg === teamRound?.checkIn?.id,
                )}
            />
          )}
        />
      </div>
    );
  };

  const timeoutAction = () => {};

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    //name the component tag
    <tournament-team-check-in>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        loading={isLoading}
      ></GSSidePanelPage>
    </tournament-team-check-in>
  );
};

//export the new name
export default TournamentTeamCheckIn;
